var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"warning"},[_c('span',{staticClass:"warning__icon",attrs:{"aria-hidden":"true"}},[_vm._v("!")]),_c('p',{staticClass:"gamma bold"},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }